import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { useRetrieveProductQuery } from '@sophocles/features/entities/products';
import ProductForm from '@sophocles/views/sales/forms/ProductForm';

function ProductFormView() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: product, isLoading } = useRetrieveProductQuery(
    { id: parseInt(productId) },
    { skip: productId == null },
  );

  const breadcrumbs = [
    { label: t('warehouse.sales', 'Sales'), to: '/sales/orders' },
    { label: t('general.products', 'Products'), to: '/sales/products' },
    {
      label: productId
        ? (product?.item_part_num ?? t('warehouse.productTitle', 'Product'))
        : t('warehouse.product.createProduct', 'Create Product'),
    },
  ];

  return (
    <AppNav loading={isLoading} page={`sales_orders_product_form`} notFullHeight={true}>
      <Box sx={{ px: 2, pb: 2, display: 'flex', flexDirection: 'column', flex: 1 }}>
        <TitleBar breadcrumbs={breadcrumbs} loading={isLoading} />
        <ProductForm
          product={product}
          onClose={() => {
            navigate('/sales/products');
          }}
        />
      </Box>
    </AppNav>
  );
}

export default ProductFormView;
